<template>
  <section class="products">
    <h1 class="tit distance"><strong>botalab</strong> Products</h1>
    <scroll-products-section :productList="productList"/>
    <a href="" class="btn_go" @click.prevent="$router.push('/products')">더보기</a>
  </section>
</template>

<script>
import ScrollProductsSection from './ScrollProductsSection.vue';

export default {
  name: 'ProductsSection',
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ScrollProductsSection,
  },
};
</script>

<style></style>
